import { html, SYSAction } from "../../../../_ovlclient/src"
import {
  HookFormChanged_Type,
  HookFormEditorAction_Type,
  HookFormEditorInit_Type,
  HookFormGetBodyRender_ReturnType,
  HookFormGetBodyRender_Type,
} from "../../../../_ovlclient/src/global/hooks"
import { GetValidFileExtensions } from "../../../src/global/globalapi"

import { DialogOkCancel } from "../../../src/library/dialog/dialogapi"
import {
  FieldIsDirty,
  FieldIsVisibleOrFillsSpace,
  FieldSetState,
  FieldSetVal,
  FieldVal,
} from "../../../src/library/forms/fieldapi"
import { FormIsDirty } from "../../../src/library/forms/formapi"
import { T } from "../../../src/textapi"
import { SYSEditorAssetDefaultFields } from "./formdef"
import {
  SYSEditorAssetDeserializeToFormFields,
  SYSEditorAssetFileGetNameAndExtension,
  SYSEditorAssetSerializeFromFormState,
} from "./helpers"

const HookFormEditorInit: SYSAction<HookFormEditorInit_Type> = async (
  value,
  { global }
) => {
  let baseFieldValue = value.parentField.convertedValue
  value.toSet.fieldsToSet = JSON.parse(
    JSON.stringify(SYSEditorAssetDefaultFields)
  )
  SYSEditorAssetDeserializeToFormFields(value.toSet.fieldsToSet, baseFieldValue)
  value.toSet.fieldsToSet["AllowUpload"].value = 1
  let extensions = await GetValidFileExtensions(undefined, value.tableDefId)
  if (extensions) {
    value.toSet.fieldsToSet["ValidExtensions"].value = extensions
  }
}

const HookFormEditorCancel: SYSAction<HookFormEditorAction_Type> = async (
  value
) => {
  if (
    !FormIsDirty(value.formState) ||
    (await DialogOkCancel(T("SYSCancel"), {
      instance: value.formState.formId,
    })) === 1
  ) {
    let browseFileEl = <HTMLInputElement>(
      document.getElementById(`ovl-assetinput-${value.parentField.id}`)
    )
    browseFileEl.value = null
    return
  } else {
    return { cancel: true }
  }
}

// const HookFormEditorDelete: SYSAction<HookFormEditorAction_Type> = async (
//   value
// ) => {
//   let fields = value.formState.fields
//   Object.keys(fields)
//     .filter((f) => f.startsWith("Val_"))
//     .forEach(async (k) => {
//       let index = k.split("_")[1]
//       await FieldSetVal(fields[`Val_${index}`], null)
//       await FieldSetVal(fields[`Ext_${index}`], null)
//     })
// }

const HookFormEditorSave: SYSAction<HookFormEditorAction_Type> = async (
  value
) => {
  if (FormIsDirty(value.formState)) {
    let val = SYSEditorAssetSerializeFromFormState(value.formState)
    let browseFileEl = <HTMLInputElement>(
      document.getElementById(`ovl-assetinput-${value.parentField.id}`)
    )

    const fileArray = Array.from(browseFileEl.files)
    await FieldSetVal(value.parentField, val)
    browseFileEl.files = undefined
    if (FieldIsDirty(value.formState.fields.SelectedFiles)) {
      value.parentField._state._files = fileArray
    }
  }
}

// if this one is present we will have the delete button always in asseteditor
// but we don't want that. so use the followng as a template if you really need a delete button
// remember. there is the set to null x button as well which might do the trick

// const HookFormEditorDelete: SYSAction<HookFormEditorAction_Type> = async (
//   value
// ) => {
//   if ((await DialogOkCancel(T("SYSEditorAssetDelete"))) === 1) {
//     FieldSetVal(value.parentField, null)
//     browseFileEl.value = null
//     return
//   }
//   return { cancel: true }
// }

const HookFormGetBodyRender: SYSAction<
  HookFormGetBodyRender_Type,
  HookFormGetBodyRender_ReturnType
> = (value, { global }) => {
  let categoryField = value.formState.fields["Category_00"]
  // value is always filename if file, link if link
  let valueFieldHtml = html`<ovl-textbox
    .props=${() => value.formState.fields["Val_00"]}
  ></ovl-textbox>`
  let fileExtFieldHtml = html`<ovl-textbox
    .props=${() => value.formState.fields["Ext_00"]}
  ></ovl-textbox>`

  let descFieldHtml
  let descField = value.formState.fields["Desc_00"]
  if (FieldIsVisibleOrFillsSpace(descField)) {
    descFieldHtml = html`<ovl-textbox .props=${() => descField}></ovl-textbox>`
  }

  let chk0FieldHtml
  let chk0Field = value.formState.fields["Chk0_00"]
  if (FieldIsVisibleOrFillsSpace(chk0Field)) {
    chk0FieldHtml = html`<ovl-checkbox
      .props=${() => chk0Field}
    ></ovl-checkbox>`
  }
  let uploadHtml

  let assetAllowUpload = FieldVal(value.formState.fields["AllowUpload"])

  let parentForm =
    global.getState().ovl.forms[value.formState.parent.formType][
      value.formState.parent.formId
    ]
  let parentField = parentForm.fields[value.formState.parent.fieldKey]

  if (assetAllowUpload && assetAllowUpload > 0) {
    uploadHtml = html`
      <div
        class="fd-file-uploader__hidden"
        aria-live="polite"
        aria-atomic="true"
      ></div>
      <input
        @change=${async (e) => {
          let fileNames: string[] = []
          for (let i = 0; i < e.target.files.length; i++) {
            let fileName = e.target.files[i].name
            if (!fileName) {
              return
            }
            fileNames.push(fileName)
          }
          await FieldSetVal(
            value.formState.fields["SelectedFiles"],
            fileNames.join("\t")
          )
        }}
        id="ovl-assetinput-${parentField.id}"
        class="fd-file-uploader__hidden"
        type="file"
      />

      <div class="fd-file-uploader ovl-assetconfig-uploader">
        <button
          @click=${() => {
            let validExtensions = FieldVal(
              value.formState.fields["ValidExtensions"]
            )
            let browseFileEl = <HTMLInputElement>(
              document.getElementById(`ovl-assetinput-${parentField.id}`)
            )
            if (validExtensions) {
              browseFileEl.setAttribute("accept", validExtensions)
            }
            browseFileEl.click()
          }}
          id="asset_browse_button1"
          class="fd-button"
          aria-label="file auswählen"
        >
          <span class="fd-button__text">${T("SYSEditorAssetChooseFile")}</span>
          <i class="sap-icon--open-folder"></i>
        </button>
      </div>
    `
  }
  let categoryHtml
  if (FieldIsVisibleOrFillsSpace(categoryField)) {
    categoryHtml = html`<ovl-listcontrol
      .props=${() => categoryField}
    ></ovl-listcontrol>`
  }
  return {
    res: html`
      ${categoryHtml} ${uploadHtml} ${chk0FieldHtml}
      <div class="ovl-asset-filedescandext">
        ${valueFieldHtml} ${fileExtFieldHtml}
      </div>
      ${descFieldHtml}
    `,
  }
}

const HookFormChanged: SYSAction<HookFormChanged_Type> = async (value) => {
  if (
    value.changedField.fieldKey === "SelectedFiles" &&
    !value.changedField.fromInit
  ) {
    let fileName = value.changedField.newValue
    let fileNameWithoutExtension
    let fileExtension
    if (fileName) {
      let file = SYSEditorAssetFileGetNameAndExtension(fileName)
      fileNameWithoutExtension = file.name
      fileExtension = file.extension
      if (value.formState.fields["Val_00"]) {
        FieldSetVal(value.formState.fields["Val_00"], fileNameWithoutExtension)
        FieldSetVal(value.formState.fields["Ext_00"], fileExtension)
      }
      // by default the description is the full filename
      // eg. used by KaltAG for "Kommission"
      if (value.formState.fields["Desc_00"]) {
        FieldSetVal(value.formState.fields["Desc_00"], fileNameWithoutExtension)
      }
    }
  } else if ((<string>value.changedField.fieldKey).startsWith("Val_")) {
    let index = (<string>value.changedField.fieldKey).split("_")[1]
    await FieldSetState(value.changedField.field, value.changedField.newValue, {
      mode: "visible/readonly",
      keepValidation: true,
    })
    if (!value.changedField.newValue) {
      await FieldSetVal(value.fields[`Ext_${index}`], null)
    }
  }
}

export let EditorDefaultHooks_SYSEditorAsset = {
  HookFormEditorInit,
  HookFormEditorCancel,
  HookFormEditorSave,
  //HookFormEditorDelete,
  HookFormChanged,
  HookFormGetBodyRender,
}
